import styled, { css } from "styled-components";

import { Fonts } from "assets/fonts";
import { animateColorsOnHover, outlineActiveElement } from "ui/styles/style-snippets";

const baseButtonStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  ${Fonts.bold_14}
  ${animateColorsOnHover}

  &:disabled {
    cursor: not-allowed;
  }
  &:focus {
    ${outlineActiveElement}
  }
`;

const baseBorderStyles = css`
  padding: 0 24px;
  border-radius: 4px;
`;

export const ButtonPrimary = styled.button`
  ${baseButtonStyles}
  ${baseBorderStyles}
  color: ${(p) => p.theme.textHighestContrastReversed};
  background-color: ${(p) => p.theme.primaryMediumContrast};
  border: 2px solid ${(p) => p.theme.primaryMediumContrast};

  &:enabled:hover {
    background-color: ${(p) => p.theme.primaryHighestContrast};
    border-color: ${(p) => p.theme.primaryHighestContrast};
  }
  &:disabled {
    background-color: ${(p) => p.theme.bgMediumContrast};
    border-color: ${(p) => p.theme.bgMediumContrast};
    color: ${(p) => p.theme.textLowContrast};
  }
`;

export const ButtonSecondary = styled.button`
  ${baseButtonStyles}
  ${baseBorderStyles}
  color: ${(p) => p.theme.primaryMediumContrast};
  background-color: ${(p) => p.theme.bgHighestContrast};
  border: 2px solid ${(p) => p.theme.primaryMediumContrast};

  &:enabled:hover {
    background-color: ${(p) => p.theme.primaryLowestContrast};
  }
  &:disabled {
    border-color: ${(p) => p.theme.bgMediumContrast};
    color: ${(p) => p.theme.textLowContrast};
  }
`;

export const ButtonTertiary = styled.button`
  ${baseButtonStyles};
  padding: 0 24px;
  color: ${(p) => p.theme.primaryMediumContrast};
  background-color: ${(p) => p.theme.bgHighestContrast};
  border: none;

  &:enabled:hover {
    color: ${(p) => p.theme.primaryHighestContrast};
  }
  &:disabled {
    color: ${(p) => p.theme.textLowContrast};
  }
`;
